import createBaseService from "@/api/base-service.ts";
import type { Role } from "../../types/role";

const roleService = {
	...createBaseService<Role>("/roles"),
};

export default roleService;
